import { createAsyncThunk } from '@reduxjs/toolkit';
import { axiosDummyInstance } from '@utils/axios/axiosInstance';
import { ITeamInfoList, ITeamCreateObj } from '@models/manager/account/accountModel';

// TopInfoQuota 데이터 요청
export const fetchTopInfoQuota = createAsyncThunk('fetchTopInfoQuota', async (params: any) => {
  try {
    const { data, status, statusText } = await axiosDummyInstance.get('/api/account/teamMemberTopInfo.json', {
      params,
    });
    if (status === 200) {
      return data;
    } else {
      throw new Error(statusText);
    }
  } catch (error) {
    console.log('fetchTopInfoQuotaError: ', error);
  }
});

// teamInfoList 데이터 요청
export const fetchTeamInfoList = createAsyncThunk('fetchTeamInfoList', async (params: any) => {
  console.log('TeamInfoListRequestParams: ', params);
  try {
    const { data, status, statusText } = await axiosDummyInstance.get('/api/account/teamInfoList.json', { params });
    if (status === 200) {
      return data;
    } else {
      throw new Error(statusText);
    }
  } catch (error) {
    console.log('fetchTeamInfoListError: ', error);
  }
});

// memberInfoList 데이터 요청
export const fetchMemberInfoList = createAsyncThunk('fetchMemberInfoList', async (params: ITeamInfoList) => {
  try {
    const { data, status, statusText } = await axiosDummyInstance.get('/api/account/memberInfoList.json', { params });
    if (status === 200) {
      return data;
    } else {
      throw new Error(statusText);
    }
  } catch (error) {
    console.log('fetchMemberInfoListError: ', error);
  }
});

// // createTeam 요청 + 완료 이후 teamInfoList 요청
// export const fetchCreateTeamInfo = createAsyncThunk('fetchCreateTeamInfo', async (params: ITeamCreateObj) => {
//   try {
//     const { data, status, statusText } = await axiosDummyInstance.get('/api/commonGetResponse.json', { params });
//     if (status === 200) {
//       const {
//         data: teamInfoListData,
//         status: teamInfoListStatus,
//         statusText: teamInfoListStatusText,
//       } = await axiosDummyInstance.get('/api/account/teamInfoList.json', { params });
//       if (teamInfoListStatus === 200) {
//         alert('Team Create Complete');
//         return teamInfoListData;
//       } else {
//         alert(`${teamInfoListStatusText} error occured`);
//         throw new Error(teamInfoListStatusText);
//       }
//     } else {
//       throw new Error(statusText);
//     }
//   } catch (error) {
//     console.log('fetchCreateTeamInfoError: ', error);
//   }
// });
